import { Button, DatePicker } from "@ds/ds-snam/react";
import { buildPopUp } from "components/PopUp";
import { ICloneReservation } from "dataModels/b2b";
import { INotificationAction, NotificationsStatusType } from "dataModels/stateModels/notification";
import { postCloneReservation } from "net/b2b";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { DsLayout, ResponseStatus, RoutePath } from "shared/constants";
import { RootState } from "state/appStore";
import { hideNotification, showNotification } from "state/reducer/notificationSlice";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";
import CalendarView from "../../calendarView";



const CloneReservation: React.FC = (): JSX.Element => {
    const { codeIup } = useParams();
    const defaultData = {
        codeIup:codeIup!,
        newDate:"",
        newTime:"00:00"
    }
    const { t, i18n } = useTranslation(['b2b', 'app']);
    const [formData,setFormData] = useState<ICloneReservation>(defaultData);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    const loadData = useCallback(() => {
        let date = new Date();
        let month=(date.getMonth()+1).toString();
        let day=date.getDate().toString()
        if(month.length===1){ month="0"+month; }
        if(day.length===1){ day="0"+day; }
        let strDate = date.getFullYear()+"-"+month+"-"+day+"T00:00:00";
        let currentFormData = {...formData};
        currentFormData.newDate=strDate;
        //console.log(currentFormData)
        setFormData(currentFormData);
    }, [dispatch]);

    useEffect(() => {
            loadData();
    }, [loadData]);

    const onDateInputChange = (event:Event) => {
        let myEvent = (event as CustomEvent).detail.dateSelection;
        let day=myEvent.substring(0,2);
        let month = myEvent.substring(3,5);
        let year = myEvent.substring(6,10);
        let strDate = year+"-"+month+"-"+day+"T00:00:00";
        let strTime = myEvent.substring(13,18);
        let currentFormData = formData;
        formData.newDate=strDate;
        formData.newTime=strTime;
        setFormData(currentFormData);
    }
    
    const saveFormData = () => {
        
        dispatch(requestPending());
        postCloneReservation(formData)
            .then((response: any) => {
                buildPopUp(dispatch,response,t,t("booking.cloneSlot.2"),'OK-422',t("booking.cloneSlot.3"),t("booking.cloneSlot.4"))
                navigate(RoutePath.B2B_BOOKINGS_INFO);

            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            })
    }
    return( 
        <>
            <p className="pageTitle">{t("booking.cloneSlot.5", {ns:['b2b']})}</p>
            <CalendarView
                showInteractions={true}
                isCloning={true}
                isCloningIup={codeIup}
            />
            {/*<div className="listTableContainerGrey" >
                <div className="boxTitle" style={{ fontSize: '25px' }}>
                    {t("booking.cloneSlot.1")}
                </div>
                <Row style={{ marginBottom: "12px" }}>
                    <Col xs={12} md={4}>
                        { formData.newDate!=='' &&
                        <DatePicker
                            id={'date-picker-id'}
                            datePickerTitle={t("booking.cloneSlot.0")}
                            isRangePicker={false}
                            datePickerVariant="has-time"
                            startingYear={1990}
                            endingYear={2099}
                            defaultDate={new Date(formData.newDate)} 
                            defaultTime={formData.newTime}
                            isDisabled={false}
                            startTime="00:00"
                            endTime="23:59"
                            timeInterval={30}
                            datePickerStatus="default"
                            confirmButtonLabel={t('calendar.popups.buttons.8')}//"Conferma"
                            hasCloseButton={false}
                            zIndex={999}
                            isReadonly={false}
                            onDateSelection={(event: Event) => {
                                onDateInputChange(event);
                            }}
                        ></DatePicker> 
                        }
                    </Col>
                </Row>
            </div>
            <Button
                style={{ float:'right',marginTop:'20px',marginLeft:'20px' }}
                id="backButton"
                buttonType="button"
                buttonUIVariant="primary"
                buttonSize="medium"
                buttonLabel="Continua"
                buttonIcon=""
                isDisabled={false}
                onClickEvent={() => {
                    saveFormData();
                }}
            />
            <Button
                style={{ float:'right',marginTop:'20px' }}
                id="backButton"
                buttonType="button"
                buttonUIVariant="secondary"
                buttonSize="medium"
                buttonLabel="Indietro"
                buttonIcon=""
                isDisabled={false}
                onClickEvent={() => {
                    navigate(RoutePath.B2B_BOOKINGS_INFO);    
                }}
            />*/}
            
        </>
    );
}
export default CloneReservation;